import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  allProducts,
  productCategories,
  categoryLinks,
  categoryToKey,
  type ProductCategory,
} from '@/mocks/products';
import ProductCard from '@/components/base/ProductCard';

export default function ProductShowcaseSection() {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState<ProductCategory>('Shoes');

  const filteredProducts = allProducts.filter((p) => p.category === activeCategory);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t('productShowcase.h2')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('productShowcase.copy')}
          </p>
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap gap-2 md:gap-3 justify-center mb-8 md:mb-12">
          {productCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium whitespace-nowrap transition-all ${
                activeCategory === cat
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              {t(`categories.${categoryToKey[cat]}`)}
            </button>
          ))}
        </div>

        {/* Products grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5 mb-8 md:mb-10">
          {filteredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* View all link */}
        <div className="text-center">
          <a
            href={categoryLinks[activeCategory]}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors"
          >
            {t('productShowcase.viewAll', { category: activeCategory })}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}